import { defineComponent } from 'vue';
import { useRouter } from 'vue-router';
export default defineComponent({
    name: 'Home',
    setup: function () {
        var router = useRouter();
        var redirecTo = function (componentName) {
            console.log('ddd');
            router.push({ name: componentName });
        };
        return {
            redirecTo: redirecTo
        };
    },
});
